<template>
  <div>
    <!-- <el-form>
      <el-form-item>
        <el-steps :active="historyActive">
          <el-step v-for="step in applicationHistory" :key="step.stepNumber" :title="step.action" :description="step.date" :icon="step.icon">
          </el-step>
        </el-steps>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Οι Αιτήσεις μου</span>
          </div>
          <div class="text item">
            <div v-show="historyActive == 1">
              dv fdkefkjcbkjeb
            </div>
          </div>
        </el-card>
      </el-form-item>
      <el-form-item style="text-align: center">
        <el-button style="margin-top: 12px;" @click="previousHistoryStep">Προηγούμενο</el-button>
        <el-button style="margin-top: 12px;" @click="nextHistoryStep">Επόμενο</el-button>
      </el-form-item>
    </el-form> -->
    <div>
      <!-- <h4>Ενέργειες-Κατάσταση Αίτησης</h4> -->
      <timeline
        ref="timeline"
        :items="timeline.items"
        :groups="timeline.groups"
        :options="timeline.options"
        @click="clicked">
      </timeline>
      <p><span v-html="stepMessage"></span></p>
      <!-- <div class="events"><p>Timeline events: <br /> {{timelineEvents}}</p></div> -->
    </div>
    <showHistoryButton
      :history="applicationHistory"
      style='float: left'
    ></showHistoryButton>
  </div>
</template>

<script>
import { Timeline } from 'vue2vis'
import '../../../node_modules/vue2vis/dist/vue2vis.css'
import { mapState } from 'vuex'
import showHistoryButton from '../base/showHistoryButton'

export default {
  props: ['applicationHistory'],
  components: {
    Timeline,
    showHistoryButton
  },
  mounted () {
    this.$store.dispatch('LOAD_PRESIDENT_DECISIONS')
  },
  data () {
    return {
      stepMessage: ''
      // historyActive: 0
    }
  },
  methods: {
    clicked (val) {
      this.stepMessage = val.item !== null
        ? this.timeline.items.find(step => step.id === val.item).title
        : ''
    }
    // timelineEvent (eventName) {
    //   if (this.timelineEvents.length > 500) this.timelineEvents = ''
    //   this.timelineEvents += `${eventName}, `
    // },
    // nextHistoryStep () {
    //   if (this.historyActive++ > this.historySteps) this.historyActive = 1
    // },
    // previousHistoryStep () {
    //   if (this.historyActive-- < 1) this.historyActive = this.historySteps
    // }
  },
  computed: {
    timeline () {
      return {
        groups: [
          { id: 0, content: 'Αιτών' },
          { id: 1, content: 'Αναμονή Ελέγχου' },
          { id: 2, content: 'Προέλεγχος' },
          { id: 3, content: 'Πρόεδρος' },
          { id: 4, content: 'Χειριστής' },
          { id: 5, content: 'Εκτελεστική Επιτροπή (ν. 3328/05)' },
          { id: 6, content: 'Αξιολογητής' },
          { id: 7, content: 'Αντιπρόεδρος Α (ν. 3328/05)' },
          { id: 8, content: 'Αντιπρόεδρος Β (ν. 3328/05)' },
          { id: 9, content: 'Διοικητικός Έλεγχος' },
          { id: 10, content: 'Σύνταξη Απόφασης' },
          { id: 11, content: 'Ειδική Επιτροπή Επανεξέτασης' },
          { id: 12, content: 'Δ/ντής Ακαδ. Αναγνώρισης' }
        ],
        items: this.applicationHistory,
        options: {
          // width: '100%',
          // margin: {
          //   item: 5
          // },
          editable: false,
          zoomMax: 100000000000,
          zoomMin: 100000009,
          tooltip: {
            overflowMethod: 'flip',
            followMouse: true
          }
        }
      }
    },
    historySteps () {
      return this.applicationHistory.length
    },
    ...mapState([
      'presidentDecisions'
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/vue2vis/dist/vue2vis.css';
</style>



// WEBPACK FOOTER //
// src/components/common/HistoryLine.vue